import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";

const slides = movies.filter((m) => m.isHot).slice(0, 5);

export default function HeroCarousel() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((c) => (c + 1) % slides.length);
    }, 5500);
    return () => clearInterval(timer);
  }, []);

  const go = (i: number) => setCurrent((i + slides.length) % slides.length);

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden bg-secondary-950">
      {slides.map((movie, i) => (
        <div
          key={movie.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === current ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <img
            src={movie.banner}
            alt={`${movie.title} 焦点图`}
            title={`${movie.title} 剧情介绍`}
            className="w-full h-full object-cover object-top animate-slow-zoom"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-secondary-950/90 via-secondary-950/55 to-secondary-950/20"></div>
        </div>
      ))}

      <div className="relative z-10 h-full w-full px-4 md:px-8 flex items-center">
        <div className="max-w-xl" key={current}>
          <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-secondary-950 text-xs font-label font-semibold mb-4 animate-fade-up">
            本周焦点
          </span>
          <h2 className="font-heading font-extrabold text-background-50 text-3xl md:text-5xl leading-tight animate-fade-up">
            {slides[current].title}
          </h2>
          <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-secondary-200 text-sm animate-fade-up">
            <span>{slides[current].type}</span>
            <span>·</span>
            <span>{slides[current].year}</span>
            <span>·</span>
            <span>{slides[current].genres.join(" / ")}</span>
            <span>·</span>
            <span className="text-accent-400 font-semibold">
              {slides[current].rating.toFixed(1)} 分
            </span>
          </div>
          <p className="mt-4 text-secondary-100 text-sm md:text-base leading-relaxed line-clamp-3 animate-fade-up">
            {slides[current].summary}
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3 animate-fade-up">
            <Link
              to={`/detail/${slides[current].id}`}
              className="px-5 py-2.5 rounded-md bg-accent-500 text-secondary-950 font-label font-semibold text-sm hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看详情
            </Link>
            <Link
              to={`/category/${slides[current].type === "电影" ? "movie" : "tv"}`}
              className="px-5 py-2.5 rounded-md border border-background-50/50 text-background-50 font-label font-medium text-sm hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              更多同类
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
        {slides.map((m, i) => (
          <button
            key={m.id}
            type="button"
            aria-label={`切换到第 ${i + 1} 张`}
            onClick={() => go(i)}
            className={`h-2 rounded-full cursor-pointer transition-all ${
              i === current ? "w-6 bg-accent-500" : "w-2 bg-background-50/50"
            }`}
          />
        ))}
      </div>

      <button
        type="button"
        aria-label="上一张"
        onClick={() => go(current - 1)}
        className="hidden md:flex absolute left-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 items-center justify-center rounded-full bg-background-50/15 text-background-50 hover:bg-background-50/30 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-2xl"></i>
      </button>
      <button
        type="button"
        aria-label="下一张"
        onClick={() => go(current + 1)}
        className="hidden md:flex absolute right-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 items-center justify-center rounded-full bg-background-50/15 text-background-50 hover:bg-background-50/30 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-2xl"></i>
      </button>
    </section>
  );
}